import { useEffect, useState } from 'react'
import { serverNow } from './serverClock'

/** How often an element on screen reads its ages again ("Seen 1 min ago", "12s ago"). */
export const AGE_EVERY_MS = 5_000

/**
 * Now on the server's clock (`serverNow`), read again every `everyMs` while `enabled` and the page is visible, for ages
 * that stay current without counting every second.
 */
export function useServerNow(enabled = true, everyMs = AGE_EVERY_MS): number {
  const [now, setNow] = useState(serverNow)
  useEffect(() => {
    if (!enabled) return
    setNow(serverNow())
    const timer = window.setInterval(() => {
      if (document.visibilityState !== 'hidden') setNow(serverNow())
    }, everyMs)
    return () => window.clearInterval(timer)
  }, [enabled, everyMs])
  return now
}
